import React, { useMemo } from 'react';
import Table from './Table';
import AlertDot from '../AlertDot';
import { ButtonPrimary } from '../Buttons';

const AlertsTable = ({
  alerts,
  onMarkReadUnread,
  showSerialColumn = false,
  initialPageSize = 10,
}) => {

  const sortedEntries = useMemo(() => {
    return Object.entries(alerts).sort(([, a], [, b]) => {
      const ta = a?.unix_time ?? 0;
      const tb = b?.unix_time ?? 0;
      if (tb !== ta) return tb - ta;          // newest → oldest
      return 0;
    });
  }, [alerts]);

  const headers = useMemo(() => {
    const base = [
      '',  
      'Error Code',
      'Description',
      'Notes',
      'Time',
      'Mark Read/Unread',
    ];
    if (showSerialColumn) {
      return ['', 'Serial', 'Error Code', 'Description', 'Notes', 'Time', 'Mark Read/Unread'];
    }
    return base;
  }, [showSerialColumn]);

  const rows = useMemo(() => {
    return sortedEntries.map(([alertId, alert]) => {
      const cells = [
        <div className="flex justify-center items-center">
          <AlertDot isRead={alert.read} />
        </div>,
      ];

      if (showSerialColumn) {
        cells.push(
          <a
            href={`/alerts/${alert.serial}`}
            className="text-primary underline underline-offset-2"
          >
            {alert.serial}
          </a>
        );
      }

      cells.push(
        alert.error_code,
        (alert.log_description ?? '').toString().replace(/[\r\n\t]+/g, ' '),
        alert.notes ?? '',
        new Date((alert.unix_time ?? 0) * 1000).toLocaleString(),
        <div className="flex justify-end">
          <ButtonPrimary onClick={() => onMarkReadUnread(alert.serial, alertId)}>
            {alert.read ? 'Mark Unread' : 'Mark Read'}
          </ButtonPrimary>
        </div>
      );

      return cells;
    });
  }, [sortedEntries, onMarkReadUnread, showSerialColumn]);

  if (!alerts || Object.keys(alerts).length === 0) {
    return <h2 className="text-xl font-bold">No alerts!</h2>;
  }

  return (
    <Table
      headers={headers}
      rows={rows}
      searchable={true}
      sortable={false} 
      paginated={true}
      initialPageSize={initialPageSize}
      pageSizeOptions={[10, 25, 50, 'all']}
      className=""
    />
  );
};

export default AlertsTable;
